import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsModule, TooltipModule } from 'ngx-bootstrap';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { SharedModule } from '../../../../shared/shared/shared.module';
import { BlKeywordInfoComponent } from './bl-keyword-info.component';
import { BlKeywordInfoBlKeywordEditComponent } from './bl-keyword-edit/bl-keyword-info-bl-keyword-edit.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
  ],
  declarations: [
    BlKeywordInfoComponent,
    BlKeywordInfoBlKeywordEditComponent,
  ]
})
export class BlKeywordInfoModule {
}
